"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hubSettings = hubSettings;

var _RequestState = _interopRequireDefault(require("lead-flows-ui/utils/RequestState"));

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

var INITIAL_STATE = {
  fetchRequestState: _RequestState.default.NOT_REQUESTED,
  updateRequestState: _RequestState.default.NOT_REQUESTED,
  settings: [{
    key: 'GDPRComplianceEnabled',
    value: 'false'
  }, {
    key: 'GDPREnforcementEnabled',
    value: 'false'
  }]
};

function hubSettings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.REQUEST_HUB_SETTINGS:
      return Object.assign({}, state, {
        fetchRequestState: _RequestState.default.REQUEST_SUBMITTED
      });

    case _ActionTypes.REQUEST_HUB_SETTINGS_SUCCESS:
      return Object.assign({}, state, {
        fetchRequestState: _RequestState.default.SUCCESS,
        settings: action.settings
      });

    case _ActionTypes.REQUEST_HUB_SETTINGS_ERROR:
      return Object.assign({}, state, {
        fetchRequestState: _RequestState.default.ERROR.withMessage(action.message)
      });

    case _ActionTypes.UPDATE_HUB_SETTINGS:
      return Object.assign({}, state, {
        updateRequestState: _RequestState.default.REQUEST_SUBMITTED
      });

    case _ActionTypes.UPDATE_HUB_SETTINGS_SUCCESS:
      return Object.assign({}, state, {
        updateRequestState: _RequestState.default.SUCCESS,
        settings: state.settings.map(function (setting) {
          if (setting.key === action.setting) {
            setting.value = action.value;
          }

          return setting;
        })
      });

    case _ActionTypes.UPDATE_HUB_SETTINGS_ERROR:
      return Object.assign({}, state, {
        updateRequestState: _RequestState.default.ERROR.withMessage(action.message)
      });

    default:
      return state;
  }
}